import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Form } from 'common/components';
import { createRoute } from 'lib/util';
import { generateEmployeesAssetsPDF } from 'lib/pdfs/EmployeesAssetsPDF';
import { formatTimeStamp } from 'lib/util';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth <= 576,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}

const Table = ({ children, bordered = false, dataCard }) => {
  const { rows, headers, config, handleClick, permissions, t = (a) => a } = dataCard;
  const {
    propsName,
    company,
    subcompany,
    actions,
    editUrl,
    togglePermission,
    editPermission,
    canRequestUpdate,
    disablePermission,
    gPDF,
    showDetail = false,
    importingModule = false,
    isImporting = false,
    handleReImportCSV = () => {},
  } = config;
  const size = useWindowSize();

  // const [collapsed, setCollapsed] = useState(false);
  // const handleToggleCollapsed = () => setCollapsed(!collapsed);

  const [collapsed, setCollapsed] = useState({});
  const handleToggleCollapsed = (index) => {
    setCollapsed((prevState) => ({ ...prevState, [index]: !Boolean(prevState[index]) }));
  };
  if (size.isMobile) {
    return (
      <div>
        {rows.map((child, index) => {
          // console.log(child);
          const {
            active = true,
            deleted = false,
            id,
            file,
            modulo,
            records,
            root = false,
          } = child.props[propsName];
          const headerReImport = child.props[propsName].header;
          const isCollapsed = !collapsed[index];
          const companyUser = child.props[propsName].company;

          return (
            <div
              className="col-sm-6 col-md-6 col-lg-4"
              style={{ 'box-shadow': '1px 1px 8px black' }}
            >
              <div
                className={classnames('card mt-5 mb-5', {
                  disabled: false,
                  // disabled: !company.active
                })}
                // onClick={handleClick}
              >
                <div className="card-body mt-5 mb-5 text-center">
                  {headers.map((header) => {
                    // Revisar si tiene un origen de datos diferente
                    let origenData = header.parent;
                    if (header.isDepreciation) {
                      origenData =
                        child.props.depreciation === 'fiscal'
                          ? '_fiscalDepreciationResult'
                          : '_financialDepreciationResult';
                    }
                    // const origenData = header.alternativePropName
                    //   ? header.alternativePropName
                    //   : propsName;

                    // Asignacion de valor, ya sea con padre o sin padre.
                    const padre = child.props[propsName][origenData];
                    const abuelo = child.props[propsName];
                    // let value2 =
                    //   (header.parent != null || header.isDepreciation) &&
                    //   (padre !== undefined || padre !== null)
                    //     ? padre[header.variable]
                    //     : abuelo[header.variable];

                    let value = '';
                    let tipo = 0;
                    if (header.isDepreciation) {
                      // Si es depreciacion
                      value = padre != null ? padre[header.variable] : '';
                      if (header.parent != null) {
                        if (padre != null) {
                          const padreSegundo = padre[header.parent] ? padre[header.parent] : {};
                          value = padreSegundo != null ? padreSegundo[header.variable] : value;
                        }
                      }
                      tipo = 1;
                    } else if (header.parent != null) {
                      // Si tiene padre
                      value = padre ? padre[header.variable] : '';
                      tipo = 2;
                    } else {
                      // Si es valor normal obtenido desde el origen
                      value = abuelo[header.variable];
                      tipo = 3;
                    }
                    if (header.variable === 'buyDate') {
                      console.log(value);
                      console.log(tipo);
                      console.log(abuelo);
                    }
                    // console.log(origenData);
                    // console.log(value);

                    // Validacion cuando el padre no exista en ese row
                    // value =
                    //   abuelo[header.parent] === undefined &&
                    //   header.parent != null
                    //     ? ""
                    //     : value;

                    if (header.pathVariable !== undefined) {
                      let path = [];
                      let pathString = header.pathVariable;
                      const pathMaximo = 10;
                      let pathContador = 0;
                      while (pathString.length > 0 && pathContador < pathMaximo) {
                        let nextDot = pathString.search(/\./);
                        let newPath = '';
                        if (nextDot > 0) {
                          newPath = pathString.substring(0, nextDot);
                          pathString = pathString.substring(nextDot + 1);
                        } else if (nextDot == -1) {
                          newPath = pathString;
                          pathString = '';
                        }
                        path.push(newPath);
                        pathContador++;
                      }
                      value = child.props[propsName];
                      path.forEach((path) => {
                        value = value[path];
                      });
                    }

                    const formatValue = (value) => {
                      let checkTraduction = true;
                      if (header.boolean) {
                        value = value ? 'Si' : 'No';
                      } else if (header.number) {
                        const presicion = header.presicion ? header.presicion : 2;
                        value = value !== '' ? value : 0;
                        value = Number(value).toFixed(presicion);
                      } else if (header.format === 'formatTimeStamp') {
                        value = value ? formatTimeStamp(value) : '';
                        checkTraduction = false;
                      }
                      value = value === undefined ? '' : value;
                      value = checkTraduction ? t('' + value) : value;

                      return value;
                    };

                    const data = () => {
                      return (
                        <texto>
                          {header.text} <b>{formatValue(value)}</b>
                        </texto>
                      );
                    };

                    if (header.type === 'h3') {
                      return <h3 className="card-title mt-0">{data()}</h3>;
                    } else if (!header.type || header.type === 'h4') {
                      return <h4 className="card-text">{data()}</h4>;
                    }
                  })}

                  {!config.noActions || config.noActions == null ? (
                    <div>
                      <h3>Acciones:</h3>
                      {permissions[editPermission] &&
                        (subcompany !== undefined ? (
                          <Form.Link
                            className="btn btn-outline-primary btn-sm mx-2"
                            to={createRoute(company.id, subcompany.id, `${editUrl}/${id}/edit`)}
                          >
                            Editar
                          </Form.Link>
                        ) : (
                          <Form.Link
                            className="btn btn-outline-primary btn-sm mx-2"
                            to={`/companies/${company.id}/${editUrl}/${id}/edit`}
                          >
                            Editar
                          </Form.Link>
                        ))}
                      {!companyUser && permissions[togglePermission] && (
                        <Form.Button
                          text={active ? 'Desactivar' : 'Activar'}
                          color={active ? 'outline-warning' : 'outline-info'}
                          extraClassName={'btn-sm'}
                          onClick={(e) => {
                            e.preventDefault();
                            handleClick(id);
                          }}
                        />
                      )}
                      {/* toggle Usuario  */}
                      {/* canToggle exclusivo de Usuarios, isRoot igual */}
                      {companyUser && permissions[togglePermission] && !root && (
                        <Form.Button
                          text={companyUser.active ? 'Desactivar' : 'Activar'}
                          color={companyUser.active ? 'outline-warning' : 'outline-info'}
                          extraClassName={'btn-sm'}
                          onClick={(e) => {
                            e.preventDefault();
                            handleClick(id);
                          }}
                        />
                      )}
                      {gPDF && (
                        <Form.Button
                          text="Exportar PDF"
                          color={active ? 'outline-primary' : 'outline-info'}
                          extraClassName={'btn-sm'}
                          onClick={(e) => {
                            e.preventDefault();
                            if (config.exportPDF) config.exportPDF(child.props[propsName]);
                            else generateEmployeesAssetsPDF(child.props[propsName], subcompany);
                          }}
                        />
                      )}
                      {gPDF && config.cardActions && config.cardActions(child.props[propsName])}
                      {permissions[canRequestUpdate] && (
                        <Form.Link
                          className="btn btn-outline-primary btn-sm mx-2"
                          to={createRoute(
                            company.id,
                            subcompany.id,
                            `${editUrl}/${id}/edit/request`
                          )}
                        >
                          Solicitar cambio
                        </Form.Link>
                      )}
                      {permissions[disablePermission] && (
                        <Form.Link
                          className="btn btn-outline-danger btn-sm mx-2"
                          to={createRoute(company.id, subcompany.id, `${editUrl}/${id}/disable`)}
                        >
                          Dar de baja
                        </Form.Link>
                      )}
                      {showDetail && (
                        <Form.Link
                          className="btn btn-outline-info btn-sm mx-2 mt-3"
                          to={createRoute(company.id, subcompany.id, `${editUrl}/${id}/detail`)}
                        >
                          Detalles
                        </Form.Link>
                      )}

                      {importingModule && (
                        <div>
                          <a
                            className="btn btn-sm btn-outline-primary"
                            href={file}
                            target="__blank"
                          >
                            <i className="fa fa-download" /> {t('import.fields.download')}
                          </a>
                          <a className="btn btn-sm">
                            <Form.Button
                              text={t('import.fields.import')}
                              isLoading={isImporting}
                              extraClassName={'btn-xs-block'}
                              onClick={(e) => {
                                if (!isImporting) {
                                  e.preventDefault();
                                  handleReImportCSV(file, modulo, headerReImport);
                                }
                              }}
                            />
                          </a>
                          <a
                            className="btn btn-outline-success btn-sm mx-2"
                            href="#expand"
                            onClick={(e) => {
                              e.preventDefault();
                              handleToggleCollapsed(index);
                            }}
                          >
                            {t(!isCollapsed ? 'Ocultar detalles' : 'Mostrar detalles')}&nbsp;
                            <i
                              className={classnames('fa', {
                                'fa-angle-down': isCollapsed,
                                'fa-angle-up': !isCollapsed,
                              })}
                            />
                          </a>
                          {!isCollapsed ? (
                            <tr className={classnames('table-active', { 'd-none': isCollapsed })}>
                              <td colSpan="7">
                                <div className="table-reponsive position-relative">
                                  <table className="table table-condensed">
                                    <thead>
                                      <tr>
                                        <th>{t('assets.fields.number')}</th>
                                        <th>Nuevo</th>
                                        <th>Exito</th>
                                        <th>Advertencias</th>
                                        <th>Errores</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {records
                                        ? records.map((r) => (
                                            <tr>
                                              {/* <tr key={r.clave}> */}
                                              <td width="10%">{r.clave}</td>
                                              <td width="10%">
                                                {t(r.new ? 'common.yes' : 'common.no')}
                                              </td>
                                              <td
                                                width="10%"
                                                className={classnames({
                                                  'table-danger': !r.success,
                                                  'table-success': r.success,
                                                })}
                                              >
                                                {t(r.success ? 'common.yes' : 'common.no')}
                                              </td>
                                              <td width="35%">
                                                <ul className="list-group">
                                                  {r.warnings.map((e, index) => (
                                                    <li key={index} className="list-group-item">
                                                      {e.error}
                                                    </li>
                                                  ))}
                                                </ul>
                                              </td>
                                              <td width="35%">
                                                <ul className="list-group">
                                                  {r.errors.map((e, index) => (
                                                    <li key={index} className="list-group-item">
                                                      {e.error}
                                                    </li>
                                                  ))}
                                                </ul>
                                              </td>
                                            </tr>
                                          ))
                                        : null}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </div>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  } else
    return (
      <div className="table-responsive" style={{ position: 'relative' }}>
        <table
          className={classnames('table table-hover table-striped', {
            'table-bordered': bordered !== false,
          })}
        >
          {children}
        </table>
      </div>
    );
};

export default Table;



// WEBPACK FOOTER //
// src/modules/common/components/List.js